import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "header_wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex justify-center align-center",
  style: {"height":"80vh"}
}
const _hoisted_4 = {
  key: 1,
  class: "contents-wrapper pt-3"
}
const _hoisted_5 = { class: "pa-1" }
const _hoisted_6 = { class: "pa-1" }
const _hoisted_7 = { class: "pa-1" }
const _hoisted_8 = { class: "pre-wrap" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "pdf_header_wrapper" }
const _hoisted_11 = { class: "pdf" }
const _hoisted_12 = ["data"]
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "fallback-link" }
const _hoisted_15 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_vue_loading = _resolveComponent("vue-loading")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_translation_modal = _resolveComponent("translation-modal")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_toolbar, {
        color: "primary",
        dark: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            onClick: _ctx.routerBack,
            icon: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createTextVNode("mdi-chevron-left", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_v_toolbar_title, {
            style: {"position":"absolute","left":"50%","transform":"translateX(-50%)","margin":"0","padding":"0","max-width":"70%","white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"},
            class: "text-center"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.childName), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_spacer),
          (!_ctx.translatedChats[_ctx.chatId])
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 0,
                onClick: _ctx.openTranslateDialog,
                icon: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                      _createTextVNode("mdi-google-translate", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.translatedChats[_ctx.chatId])
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 1,
                onClick: _ctx.returnTranslate,
                icon: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                      _createTextVNode("mdi-arrow-u-left-top", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    (_ctx.fetchLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_vue_loading, {
            active: _ctx.fetchLoading,
            loader: "bars",
            color: "#EE6090",
            size: { width: '30px', height: '30px' }
          }, null, 8, ["active"])
        ]))
      : (_ctx.chat)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "pa-1 grey-wrapper" }, [
              _createElementVNode("h5", null, "日付")
            ], -1)),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", null, _toDisplayString(_ctx.dayFormat(_ctx.chat.date)), 1)
            ]),
            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "pa-1 grey-wrapper" }, [
              _createElementVNode("h5", null, "タイトル")
            ], -1)),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("p", null, _toDisplayString(_ctx.displayTitle), 1)
            ]),
            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "pa-1 grey-wrapper" }, [
              _createElementVNode("h5", null, "本文")
            ], -1)),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.displayBody), 1)
            ]),
            (_ctx.chat.attachmentUrls.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _cache[9] || (_cache[9] = _createElementVNode("div", { class: "pa-1 grey-wrapper" }, [
                    _createElementVNode("h5", null, "添付ファイル")
                  ], -1)),
                  _createElementVNode("div", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chat.attachmentUrls, (au, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: au.objectKey
                      }, [
                        (!_ctx.isPdf(au.objectKey))
                          ? (_openBlock(), _createBlock(_component_v_card, {
                              key: 0,
                              onClick: ($event: any) => (_ctx.openImg(_ctx.chat, index)),
                              class: "pointer ma-1",
                              elevation: "0"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_img, {
                                  src: au.url ?? undefined,
                                  contain: ""
                                }, null, 8, ["src"])
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : (_openBlock(), _createBlock(_component_v_btn, {
                              key: 1,
                              class: "my-3 mx-1",
                              color: "primary",
                              dark: "",
                              small: "",
                              onClick: ($event: any) => (_ctx.openImg(_ctx.chat, index)),
                              loading: _ctx.imgLoading
                            }, {
                              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                _createTextVNode(" 表示する ", -1)
                              ]))]),
                              _: 1
                            }, 8, ["onClick", "loading"]))
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.isTranslationDialog,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isTranslationDialog) = $event)),
      persistent: "",
      "max-width": "400px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_translation_modal, {
          isOpen: _ctx.isTranslationDialog,
          childId: _ctx.childId,
          selectedChat: _ctx.translationChat,
          onTranslate: _ctx.onTranslated,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isTranslationDialog = false))
        }, null, 8, ["isOpen", "childId", "selectedChat", "onTranslate"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      class: "pt-5",
      modelValue: _ctx.isAttachmentUrls,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isAttachmentUrls) = $event)),
      fullscreen: "",
      "hide-overlay": "",
      transition: "dialog-bottom-transition"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "pdf_wrapper pa-0" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_v_toolbar, {
                class: "pdf_header",
                dark: "",
                color: "primary"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    icon: "",
                    dark: "",
                    onClick: _ctx.closeChatImg,
                    absolute: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                          _createTextVNode("mdi-close", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_toolbar_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.childName), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_spacer)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.showingUrls, (u) => {
                return (_openBlock(), _createElementBlock("div", { key: u }, [
                  _createElementVNode("object", {
                    data: u,
                    type: "application/pdf",
                    width: "100%",
                    height: "100%"
                  }, [
                    _createElementVNode("iframe", {
                      src: u.url,
                      width: "100%",
                      height: "100%",
                      frameborder: "0",
                      allowfullscreen: ""
                    }, " お使いのブラウザは iframe に対応していません。 ", 8, _hoisted_13),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("a", {
                        href: u.url,
                        target: "_blank",
                        rel: "noopener"
                      }, " PDF をダウンロード ", 8, _hoisted_15)
                    ])
                  ], 8, _hoisted_12)
                ]))
              }), 128))
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.isImgDialog,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.isImgDialog) = $event)),
      fullscreen: "",
      transition: "dialog-bottom-transition"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          width: "100%",
          rounded: "b-0",
          class: "img_dialog pa-0"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              height: "40px",
              class: "d-flex justify-end align-center px-2 img_dialog-header",
              rounded: "b-0",
              dark: "",
              elevation: "0"
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", {
                  class: "blue--text",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isImgDialog = false))
                }, "閉じる")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card, {
              height: "calc(100vh - 40px)",
              width: "100%",
              rounded: "0",
              dark: "",
              class: "d-flex flex-grow-1"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_img, {
                  class: "img_dialog-img",
                  width: "100%",
                  contain: "",
                  src: _ctx.notPdfImgSrc ?? undefined,
                  alt: "img"
                }, null, 8, ["src"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}